import React, { useEffect, useState } from "react"
import { PDFDocument, rgb } from "pdf-lib"
import log from "loglevel"
import UAI from "../UAI"
import fontkit from "@pdf-lib/fontkit"
import logoUAI from "../img/LogoUAI-black.png"
import Loading from "../Utils/Loading"

const FolletoPdf = (props) => {
  const [pdfBase64, setPdfBase64] = useState(null)

  const cuentaLineasContenido = (text, fonts, maxwidth) => {
    const spaceSize = fonts["thesansregular"].widthOfTextAtSize(" ", 16)
    let lines = 0
    text.split(/\n/).forEach((line) => {
      log.info("Line:" + line)
      lines++
      let linesize = fonts["thesansregular"].widthOfTextAtSize(line, 16)
      if (linesize < maxwidth) {
        log.info(
          "Size:" + linesize + " Lines:" + lines + " Line:_" + line + "_"
        )
        return
      }
      let size = 0
      line.split(/\s/).forEach((word) => {
        let wordsize = fonts["thesansregular"].widthOfTextAtSize(word, 16)
        if (size + wordsize + spaceSize > maxwidth) {
          size = wordsize + spaceSize
          lines++
        } else {
          size = size + wordsize + spaceSize
        }
        log.info(
          "Size:" +
            wordsize +
            " Lines:" +
            lines +
            " Word:_" +
            word +
            "_" +
            " LineSize:" +
            size
        )
      })
    })
    return lines
  }

  useEffect(() => {
    const assets = [
      {
        key: "pdf",
        url: "/ficha06.pdf",
        contenttype: "application/pdf",
      },
      {
        key: "thesanssemibold",
        url: "/fonts/TheSans SemiBold.otf",
        contenttype: "font/otf",
      },
      {
        key: "thesansregular",
        url: "/fonts/TheSans Regular.otf",
        contenttype: "font/otf",
      },
      {
        key: "thesansregularcaps",
        url: "/fonts/TheSans RegularCaps.otf",
        contenttype: "font/otf",
      },
      {
        key: "thesansboldcaps",
        url: "/fonts/TheSans BoldCaps.otf",
        contenttype: "font/otf",
      },
    ]
    const loadPdf = async (results) => {
      log.info("Async function!")
      const pdfDoc = await PDFDocument.load(results["pdf"])
      pdfDoc.registerFontkit(fontkit)
      const fonts = {}
      const allresults = await Promise.allSettled(
        assets.map(
          (asset) =>
            new Promise((resolve, reject) => {
              if (asset.contenttype === "font/otf") {
                pdfDoc
                  .embedFont(results[asset.key])
                  .then((result) => {
                    fonts[asset.key] = result
                    resolve()
                  })
                  .catch((error) => {
                    log.error(error)
                    reject(error)
                  })
              } else {
                resolve()
              }
            })
        )
      )
      let allok = true
      allresults.forEach((res) => {
        if (res.status !== "fulfilled") {
          allok = false
        }
      })
      if (!allok) {
        log.error("Error embedding fonts in PDF!")
        return {}
      }

      const copiedPages = await pdfDoc.copyPages(pdfDoc, [
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        4,
      ])
      return {
        pdfDoc: pdfDoc,
        fonts: fonts,
        recurring: copiedPages,
        final: copiedPages[9],
      }
    }

    /**
     *
     * @param {Object} cohorte la cohorte a dibujar
     * @param {function} cuentaLineasContenido Función que cuenta las líneas de contenido de un texto en particular
     * @param {Object} fonts los fonts para escribir
     * @param {Object} pdfDoc el documento PDF
     * @param {*} loadedPdf
     * @param {*} pages
     * @returns
     */
    function dibujaContenidosCohorte(
      cohorte,
      cuentaLineasContenido,
      fonts,
      pdfDoc,
      loadedPdf,
      pages
    ) {
      let contenidos_json = {}

      try {
        contenidos_json = JSON.parse(cohorte.contenidos_detallados)
      } catch (e) {
        log.debug(e)
        log.debug(contenidos_json)
        log.warn("Cohorte " + cohorte.sigla + " sin contenidos detallados")
        contenidos_json = {}
      }

      log.info(contenidos_json)
      const titulo = contenidos_json.Titulo
      const contenidos = contenidos_json["Contenidos por clase o módulo"] || []

      let contenidosProcesados = {}
      let columna = 1
      let currentPage = 0
      let currentY = 768 - 214 - 12
      let totalPages = 0
      let lastPageHasSingleColumn = true
      contenidos.forEach((contenido, idx) => {
        // Número de líneas que ocupará el título
        let linesTitulo = cuentaLineasContenido(contenido["Título"], fonts, 311)
        let linesContenido = cuentaLineasContenido(
          contenido["Listado de contenidos"],
          fonts,
          311
        )
        // Calcula el alto de acuerdo al alto de cada línea
        let heightTitulo = (linesTitulo + 1) * 19.2
        // Calcula el alto de acuerdo al alto de cada línea
        let heightContenido = (linesContenido + 1) * 19.2
        // Salto de columna o página cuando el alto se pasará de los márgenes
        if (currentY - heightTitulo - heightContenido < 60) {
          if (columna === 1) {
            columna = 2
            lastPageHasSingleColumn = false
          } else {
            // Agregar página
            columna = 1
            lastPageHasSingleColumn = true
            currentPage++
          }
          currentY = 768 - 214 - 12
        }
        // Inicializamos contenidos procesados
        contenidosProcesados[currentPage] =
          contenidosProcesados[currentPage] || []
        contenidosProcesados[currentPage].push({
          pagina: currentPage,
          clase: idx + 1,
          titulo: titulo,
          contenido: titulo + " " + (idx + 1) + " " + contenido["Título"],
          detalles: contenido["Listado de contenidos"].toString(),
          columna: columna,
          lineas: linesTitulo + linesContenido,
          y: currentY,
          heightTitulo: heightTitulo,
          heightContenido: heightContenido,
        })
        currentY = currentY - 19.2 - 36 - heightTitulo - heightContenido
        if (currentPage > totalPages) {
          totalPages = currentPage
        }
      })

      log.info(contenidosProcesados)
      log.info(currentPage)
      log.info(totalPages)

      if (lastPageHasSingleColumn) {
        pdfDoc.removePage(3)
      } else {
        pdfDoc.removePage(4)
      }

      for (let i = 0; i < totalPages; i++) {
        pdfDoc.insertPage(3, loadedPdf.recurring[i])
      }

      log.debug(totalPages)
      if (totalPages === 0) {
        pdfDoc.removePage(3)
      }

      pages = pdfDoc.getPages()

      // Página por página
      Object.values(contenidosProcesados).forEach((pagina, idxp) => {
        let currentPageNumber = 3 + idxp
        let currentPage = pages[currentPageNumber]
        // Número de página
        currentPage.drawText((currentPageNumber + 1).toString().toUpperCase(), {
          x: 116,
          y: 65,
          size: 14,
          maxWidth: 311,
          lineHeight: 19.2,
          font: fonts["thesanssemibold"],
          color: rgb(0 / 255, 84 / 255, 237 / 255),
        })
        // Por cada unidad de contenido
        pagina.forEach((contenido, idx) => {
          let x = contenido.columna === 1 ? 117 : 602
          currentPage.moveTo(x, contenido.y)
          log.debug(
            "Dibujando página " +
              currentPageNumber +
              " clase " +
              (idx + 1) +
              " en " +
              x +
              "," +
              contenido.y
          )
          // Dibuja título de la clase
          currentPage.drawText(contenido.contenido.toUpperCase(), {
            size: 16,
            maxWidth: 311,
            lineHeight: 19.2,
            font: fonts["thesanssemibold"],
            color: rgb(0 / 255, 84 / 255, 237 / 255),
          })
          // Baja y dibuja los contenidos de la clase
          currentPage.moveDown(contenido.heightTitulo)
          currentPage.drawText(contenido.detalles, {
            size: 16,
            maxWidth: 311,
            lineHeight: 19.2,
            font: fonts["thesansregular"],
            color: rgb(1 / 255, 1 / 255, 1 / 255),
          })
          currentPage.moveDown(contenido.heightContenido)
        })
      })

      if (lastPageHasSingleColumn) {
        let previousToLastPage = pages[pages.length - 2]
        let text =
          '"Mi experiencia fue excelente, me permitió después de 15 años retomar mis estudios y ponerlos en práctica. Además la flexibilidad horaria y la forma en que se plantean los contenidos me permitió mantener mi vida normal estudiando"'
        previousToLastPage.drawText(text, {
          x: 602,
          y: 768 - 243 - 12,
          size: 18,
          maxWidth: 311,
          lineHeight: 19.2,
          font: fonts["thesansregular"],
          color: rgb(1, 1, 1),
        })
        let alumno = "Ex alumno UAI Online"
        previousToLastPage.drawText(alumno, {
          x: 722,
          y: 768 - 383 - 12,
          size: 18,
          maxWidth: 311,
          lineHeight: 19.2,
          font: fonts["thesanssemibold"],
          color: rgb(1, 1, 1),
        })
      }
      return pages
    }

    if (!props.cohorte) {
      throw new Error("Parámetros inválidos, requerimos un cohorte")
    }

    console.log(Object.keys(props.cohorte))
    console.log(typeof props.cohorte)
    console.log(props.cohorte.plantilla_folleto)

    // Si es diplomado, tenemos que conseguir los datos de los cursos que lo contienen.
    if (props.cohorte.GradoId === 1) {
    }

    let results = []
    Promise.allSettled(
      assets.map(
        (asset) =>
          new Promise((resolve, reject) => {
            let url = asset.url
            if (
              asset.key === "pdf" &&
              props.cohorte.plantilla_folleto === "Cursos abiertos - Negocios"
            ) {
              url = "/fichacursosabiertosnegocios.pdf"
            } else {
              console.log("_" + props.cohorte.plantilla_folleto + "_")
            }

            window
              .fetch(UAI.wwwroot() + url, {
                method: "GET",
                headers: {
                  "Content-Type": asset.contenttype,
                },
              })
              .then((response) => {
                response
                  .arrayBuffer()
                  .then((buffer) => {
                    // Load a PDFDocument from the existing PDF bytes
                    results[asset.key] = new Uint8Array(buffer)
                    log.debug(asset.key + " cargado desde " + url)
                    resolve()
                  })
                  .catch((e) => {
                    console.error(e)
                    reject()
                  })
              })
              .catch((e) => {
                console.error(e)
                reject()
              })
          })
      )
    ).then((allresults) => {
      let allok = true
      allresults.forEach((res) => {
        if (res.status !== "fulfilled") {
          allok = false
        }
      })

      if (allok) {
        // Load a PDFDocument from the existing PDF bytes
        loadPdf(results).then((loadedPdf) => {
          const pdfDoc = loadedPdf.pdfDoc
          const fonts = loadedPdf.fonts
          let cohorte = props.cohorte
          log.debug(cohorte)

          // Páginas de la plantilla
          let pages = pdfDoc.getPages()
          const firstPage = pages[0]

          /** PORTADA **/
          // Nombre del grado (Curso o Diplomado)
          firstPage.drawText(UAI.nombresGrados[cohorte.gradoid].toUpperCase(), {
            x: 602,
            y: 447,
            size: 24,
            maxWidth: 321,
            lineHeight: 38,
            font: fonts["thesanssemibold"],
            color: rgb(1, 1, 1),
          })

          // Nombre de la cohorte
          firstPage.drawText(
            cohorte.nombre
              .replace("Diplomado en ", "")
              .replace(" - Online", ""),
            {
              x: 602,
              y: 352,
              size: 33,
              maxWidth: 321,
              lineHeight: 38,
              font: fonts["thesansboldcaps"],
              color: rgb(1, 1, 1),
            }
          )

          // Año inicio
          firstPage.drawText(cohorte.año_inicio.toString(), {
            x: 106,
            y: 70,
            size: 22,
            maxWidth: 290,
            lineHeight: 38,
            font: fonts["thesansboldcaps"],
            color: rgb(0, 0, 0),
          })

          /** BIENVENIDA **/
          const secondPage = pages[1]

          // Bienvenida
          secondPage.drawText(cohorte.Bienvenida || "", {
            x: 551,
            y: 768 - 125 - 12, //630,
            size: 18,
            maxWidth: 411,
            lineHeight: 21.6,
            font: fonts["thesansregularcaps"],
            color: rgb(0 / 255, 84 / 255, 237 / 255),
          })

          // Bajada de título
          secondPage.drawText(cohorte.BajadaTitulo || "", {
            x: 551,
            y: 768 - 467 - 32, // 290,
            size: 16,
            maxWidth: 411,
            lineHeight: 19.2,
            font: fonts["thesanssemibold"],
            color: rgb(1 / 255, 1 / 255, 1 / 255),
          })

          /** OBJETIVOS **/
          const thirdPage = pages[2]

          // Objetivo
          thirdPage.drawText(cohorte.objetivo || "", {
            x: 117,
            y: 768 - 213 - 12, // 290,
            size: 16,
            maxWidth: 311,
            lineHeight: 19.2,
            font: fonts["thesansregular"],
            color: rgb(1 / 255, 1 / 255, 1 / 255),
          })

          // Público objetivo
          thirdPage.drawText(cohorte.publicoobjetivo || "", {
            x: 117,
            y: 768 - 213 - 12 - 290, // 290,
            size: 16,
            maxWidth: 311,
            lineHeight: 19.2,
            font: fonts["thesanssemibold"],
            color: rgb(1 / 255, 1 / 255, 1 / 255),
          })

          /** Contenidos detallados **/
          pages = dibujaContenidosCohorte(
            cohorte,
            cuentaLineasContenido,
            fonts,
            pdfDoc,
            loadedPdf,
            pages
          )

          /** CONTACTO **/
          let lastpage = pages[pages.length - 1]

          // Más información
          lastpage.drawText("Contacto información e inscripciones", {
            x: 602,
            y: 768 - 243 - 12, // 290,
            size: 21,
            maxWidth: 311,
            lineHeight: 19.2,
            font: fonts["thesansboldcaps"],
            color: rgb(1, 1, 1),
          })

          // Inscripciones
          lastpage.drawText(
            (cohorte.NombreCoordinadorAdmision || "") +
              "\nEmail: " +
              (cohorte.EmailCoordinadorAdmision ||
                "admisionpostgrados@uai.cl") +
              "\nwww.uai.cl/online",
            {
              x: 602,
              y: 768 - 302 - 12, // 290,
              size: 16,
              maxWidth: 311,
              lineHeight: 19.2,
              font: fonts["thesanssemibold"],
              color: rgb(1, 1, 1),
            }
          )

          // Serializar el PDFDocument a bytes (a Uint8Array)
          pdfDoc.saveAsBase64({ dataUri: true }).then((base64) => {
            setPdfBase64(base64)
          })
        })
      }
    })
  }, [props.cohorte])

  if (pdfBase64 === null) {
    return (
      <div
        className="loading-folleto"
        style={{ backgroundImage: `url(${logoUAI})` }}
      >
        <Loading size={25} />
      </div>
    )
  }

  return (
    <embed
      src={pdfBase64}
      style={{ width: "100%", height: "100%" }}
      title={"Folleto-" + props.cohorte.id}
      onMouseMove={(event) => {
        log.info("Moving the mouse!")
      }}
      onScroll={(event) => {
        log.info("Scrolling!")
      }}
    ></embed>
  )
}
export default FolletoPdf
